module.exports = __webpack_public_path__ + "static/ramon-7de8fb64e4de240a74247af6d0c9bfb3.webp";